import { createContext } from 'react';

export type AgreementCtx = {
  showVoidAgreementConfirmAlert: boolean;
  showViewAgreementFailAlert: boolean;
};

const AgreementContext = createContext<AgreementCtx>({
  showVoidAgreementConfirmAlert: false,
  showViewAgreementFailAlert: false,
});

export default AgreementContext;
